import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { AdTopBanner, AdBottomBanner } from '../components/AdSense';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <AdTopBanner />
          
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">About</span>
          </nav>

          <h1 className="text-3xl font-bold text-white mb-6">About PercentageCalculatorPlus</h1>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Our Mission</h2>
              <p className="text-gray-300 leading-relaxed">
                PercentageCalculatorPlus is dedicated to providing free, accurate, and easy-to-use calculators for everyone. 
                Whether you need to calculate percentages, plan your finances, track your health metrics, or solve mathematical problems, 
                we have the tools to help you get quick and reliable results.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">What We Offer</h2>
              <ul className="text-gray-300 space-y-2">
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span><strong>40+ Free Calculators</strong> - From financial planning to health tracking</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span><strong>No Registration Required</strong> - Use all calculators instantly without signing up</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span><strong>Mobile Friendly</strong> - Access calculators on any device</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span><strong>Accurate Results</strong> - Thoroughly tested calculations you can trust</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Categories</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <Link to="/financial-calculators" className="bg-[#0d0d0d] border border-[#2a2a2a] rounded-lg p-4 text-center hover:border-cyan-500/50 transition-colors">
                  <div className="text-2xl mb-2">💰</div>
                  <div className="text-gray-300 text-sm">Financial</div>
                </Link>
                <Link to="/fitness-calculators" className="bg-[#0d0d0d] border border-[#2a2a2a] rounded-lg p-4 text-center hover:border-cyan-500/50 transition-colors">
                  <div className="text-2xl mb-2">💪</div>
                  <div className="text-gray-300 text-sm">Fitness & Health</div>
                </Link>
                <Link to="/math-calculators" className="bg-[#0d0d0d] border border-[#2a2a2a] rounded-lg p-4 text-center hover:border-cyan-500/50 transition-colors">
                  <div className="text-2xl mb-2">🔢</div>
                  <div className="text-gray-300 text-sm">Math</div>
                </Link>
                <Link to="/other-calculators" className="bg-[#0d0d0d] border border-[#2a2a2a] rounded-lg p-4 text-center hover:border-cyan-500/50 transition-colors">
                  <div className="text-2xl mb-2">🛠️</div>
                  <div className="text-gray-300 text-sm">Other</div>
                </Link>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Contact Us</h2>
              <p className="text-gray-300">
                Have questions, suggestions, or feedback? We'd love to hear from you! 
                Visit our <Link to="/contact" className="text-cyan-400 hover:text-cyan-300">Contact Page</Link> to get in touch.
              </p>
            </section>
          </div>

          <AdBottomBanner />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
